import React from 'react';

import { finishInsertingRoofPlane } from '../../../../../store/actions/layout/roofPlaneActions';
import { updateInsertingRoofPlane } from '../../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { PlaneInsertionSubPanel } from './PlaneInsertionSubPanel';

export function RoofPlaneInsertionSubPanel() {
  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);
  const dispatch = useAppDispatch();

  if (insertingObjectInfo?.type !== 'roofPlane') return null;

  return (
    <PlaneInsertionSubPanel
      type="roof"
      insertionPlane={insertingObjectInfo.data}
      onChange={(changes) => {
        dispatch(updateInsertingRoofPlane(changes));
      }}
      onInsert={async () => {
        await dispatch(finishInsertingRoofPlane());
      }}
      onInsertAndRepeat={async () => {
        await dispatch(finishInsertingRoofPlane({ postInsertionAction: 'repeat' }));
      }}
    />
  );
}
